<template>
  <div class="shop-main">
    <Header2 />
    <div class="header-placeholer" />
    <div class="main">
      <div class="menu-wrap">
        <MenuSlider :menuList="routerData" :default-active="activePath" />
      </div>
      <main>
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import Header2 from "@/components/Header2.vue";
import MenuSlider from "../MenuSlider.vue";
import { shopRouter } from "../../router";
export default {
  components: { Header2, MenuSlider },
  computed: {
    routerData() {
      return shopRouter[0].children;
    },
    activePath() {
      return this.$route.path;
    },
  },
  data() {
    return {};
  },
};
</script>
<style scoped lang="less">
.shop-main {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  .header-placeholer {
    height: 80px;
  }
  .main {
    flex: 1;
    height: 100%;

    main {
      flex: 1;
      min-height: calc(100vh - 80px);
      background-color: var(--bg-color2);
      padding-left: 220px;
    }
  }

  .menu-wrap {
    width: 220px;
    position: fixed;
    top: 80px;
    left: 0;
    height: calc(100% - 80px);
    overflow-y: auto;
    background-color: var(--bg-color);
  }
}
</style>
